import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createArticleCategory(_, articleCategory) {
    const response = await axios.post('/blade/article-categories', articleCategory);
    return response.data.articleCategory;
  },
  async getArticleCategories() {
    const response = await axios.get('/blade/article-categories');
    return response.data.articleCategories;
  },
  async getArticleCategory(_, { articleCategoryId }) {
    const { data } = await axios.get(`/blade/article-categories/${articleCategoryId}`);
    return data;
  },
  async getArticleCategoryTypes() {
    const { data } = await axios.get('/blade/article-categories/types');
    return data;
  },
  async updateArticleCategory(_, articleCategory) {
    const response = await axios.patch(`/blade/article-categories/${articleCategory._id}`, articleCategory);
    return response.data.articleCategory;
  },
  async deleteArticleCategory(_, { articleCategoryId, _id }) {
    const did = articleCategoryId || _id;
    const response = await axios.delete(`/blade/article-categories/${did}`);
    return response.data.articleCategory;
  },
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/article-categories.js